<div class="add-container">
    <div class="d-flex justify-content-between align-items-center">
        <h1 class="add-title m-0 p-0">Adaugă un nou document(Ieșire)</h1>
        <button class="action-buttons-side" (click)="closeDialog()">x</button>
    </div>
    <div *ngIf="docData" class="mb-2">
        <span style="color: red; font-size: 16px;">(Registru selectat: <strong><u>{{ selectedSerieDocument
                    }}</u></strong>)</span>
    </div>
    <form [formGroup]="form">
        <br>
        <div *ngIf="docData" class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill">
                    <mat-label>Tip emitere număr document nou </mat-label>
                    <mat-select formControlName="new_number">
                        <mat-option *ngFor="let option of newNumberOptions"
                            [value]="option.id">{{option.name}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['new_number'].valid && form.controls['new_number'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div *ngIf="!docData" class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill">
                    <mat-label>Registru/Serie/Lot</mat-label>
                    <mat-select formControlName="id_serie" (selectionChange)="onRegisteActiveSelected($event.value)">
                        <mat-option *ngFor="let option of registreActiveSwitch"
                            [value]="option.id">{{option.name}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_serie'].valid && form.controls['id_serie'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <ng-container *ngIf="registruOficialGeneralValue != form.get('id_serie')?.value && showRegistreFields">
            <div class="row">
                <div [ngClass]="form.get('registratura_number_type')?.value === 1 ? 'col-md-12' : 'col-md-6'">
                    <mat-form-field appearance="fill">
                        <mat-label>Formalitate inregistrare</mat-label>
                        <mat-select formControlName="registratura_number_type"
                            (selectionChange)="onRegistraturaTypeSelected($event.value)">
                            <mat-option *ngFor="let option of registreOptions"
                                [value]="option.id">{{option.name}}</mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="!form.controls['registratura_number_type'].valid && form.controls['registratura_number_type'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6" *ngIf="form.get('registratura_number_type')?.value === 2">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr Document (Răspuns/Ieșire)</mat-label>
                        <input type="number" matInput formControlName="registratura_number" />
                        <mat-error
                            *ngIf="!form.controls['registratura_number'].valid && form.controls['registratura_number'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="registruOficialGeneralValue != form.get('id_serie')?.value && showProceduraField">
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field appearance="fill">
                        <mat-label>Procedură ieșire document</mat-label>
                        <mat-select formControlName="exit_document_format"
                            (selectionChange)="onProceduraIesireSelected($event.value)">
                            <mat-option *ngFor="let option of proceduriDocumentOptions"
                                [value]="option.id">{{option.name}}</mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="!form.controls['exit_document_format'].valid && form.controls['exit_document_format'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>
        <div class="row">
            <div class="col-md-10">
                <mat-form-field appearance="fill">
                    <mat-label>Cale de ieșire</mat-label>
                    <mat-select formControlName="source" (selectionChange)="addSerie()">
                        <mat-option *ngFor="let optionSursa of surse" [value]="optionSursa.id">
                            {{ optionSursa.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['source'].valid && form.controls['source'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-2">
                <button type="button" class="btn btn-sm btn-primary btn-add-serie w-100" (click)="addSerie()">
                    <i class="fa-solid fa-plus"></i>
                    Adaugă cale
                </button>
            </div>
        </div>

        <div *ngIf="!sourceArr.length" class="mb-3">
            <mat-error>
                Adăugați minim o cale de intrare
            </mat-error>
        </div>

        <div *ngIf="sourceArr.length" class="mb-3">
            <mat-chip-listbox aria-label="Căi de intrare">
                <mat-chip *ngFor="let sursa of sourceArr; let i = index" (removed)="removeSerie(i)">
                    {{sursa.name}}
                    <button matChipRemove [attr.aria-label]="'remove ' + sursa.name">
                        <mat-icon class="serie-remove-icon">cancel</mat-icon>
                    </button>
                </mat-chip>
            </mat-chip-listbox>
        </div>

        <div class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill">
                    <mat-label>Tip Document</mat-label>
                    <input matInput [formControl]="tipDocumenteControl" [matAutocomplete]="autoTipDocumente"
                        (blur)="onTipDocumenteBlur()" />
                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                    <mat-autocomplete #autoTipDocumente="matAutocomplete" [displayWith]="displayTipDocumente"
                        (optionSelected)="onTipDocumenteSelected($event.option.value)">
                        <mat-option *ngIf="showTipDocumenteMessage" disabled>
                            <span *ngIf="!tipDocumenteControl.value || tipDocumenteControl.value.length < 2">
                                Vă rugăm să introduceți 2 caractere sau mai multe
                            </span>
                            <span
                                *ngIf="isTipDocumenteLoading && tipDocumenteControl.value && tipDocumenteControl.value.length >= 2">Căutare...</span>
                            <span
                                *ngIf="!isTipDocumenteLoading && tipDocumenteLoadComplete && tipDocumente.length === 0 && tipDocumenteControl.value && tipDocumenteControl.value.length >= 2">
                                Nu au fost găsite rezultate
                            </span>
                        </mat-option>

                        <mat-option *ngFor="let doc of tipDocumente" [value]="doc">
                            {{ doc.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="!tipDocumenteControl.valid && tipDocumenteControl.touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <ng-container *ngIf="!docData">
            <h3 class="m-0">Emitent</h3>
            <mat-divider class="divider-section"></mat-divider>
            <br>
            <form [formGroup]="formSecundar">
                <div class="divider-container">
                    <div class="line"></div>
                    <span class="text">IDENTIFICARE EMITENT</span>
                    <div class="line"></div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Instituție/Direcție</mat-label>
                            <input matInput [formControl]="directiiSecundarControl"
                                [matAutocomplete]="autoDirectiiSecundar" (blur)="onDirectiiSecundarBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoDirectiiSecundar="matAutocomplete"
                                [displayWith]="displayDirectiiSecundar"
                                (optionSelected)="onDirectiiSecundarChange($event.option.value)">
                                <mat-option *ngIf="filteredDirectiiSecundar.length === 0" disabled>
                                    Nu au fost găsite rezultate
                                </mat-option>
                                <mat-option *ngFor="let directie of filteredDirectiiSecundar" [value]="directie">
                                    {{ directie.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Compartiment/Departament</mat-label>
                            <input matInput [formControl]="compartimenteSecundarControl"
                                [matAutocomplete]="autoCompartimenteSecundar" (blur)="onCompartimenteSecundarBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoCompartimenteSecundar="matAutocomplete"
                                [displayWith]="displayCompartimenteSecundar"
                                (optionSelected)="onCompartimenteSecundarSelected($event.option.value)">
                                <mat-option *ngIf="showCompartimenteSecundarMessage" disabled>
                                    <span
                                        *ngIf="!compartimenteSecundarControl.value || compartimenteSecundarControl.value.length < 2">
                                        Vă rugăm să introduceți 2 caractere sau mai multe
                                    </span>
                                    <span
                                        *ngIf="isCompartimenteSecundarLoading && compartimenteSecundarControl.value && compartimenteSecundarControl.value.length >= 2">Căutare...</span>
                                    <span
                                        *ngIf="!isCompartimenteSecundarLoading && compartimenteSecundarLoadComplete && compartimenteSecundar.length === 0 && compartimenteSecundarControl.value && compartimenteSecundarControl.value.length >= 2">
                                        Nu au fost găsite rezultate
                                    </span>
                                </mat-option>

                                <mat-option *ngFor="let compartiment of compartimenteSecundar" [value]="compartiment">
                                    {{ compartiment.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Alegeți un operator</mat-label>
                            <mat-select formControlName="user_id"
                                (selectionChange)="onOperatoriSecundarChange($event.value)">
                                <!-- <mat-form-field class="px-2 sticky-input">
                                    <input matInput [formControl]="operatoriSecundarControl"
                                        (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                </mat-form-field> -->

                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let operator of filteredOperatoriSecundar" [value]="operator.id">
                                    {{ operator.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </ng-container>

        <h3 class="m-0">Informații</h3>
        <mat-divider class="divider-section"></mat-divider>
        <br>
        <div *ngIf="!docData" class="row">
            <div class="col-md-6">
                <mat-form-field appearance="fill">
                    <mat-label>Referire la Număr anterior (Intrare)</mat-label>
                    <input matInput formControlName="parent_no" />
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field appearance="fill">
                    <mat-label>Anul - Documentului de Referință</mat-label>
                    <input matInput type="number" formControlName="parent_year" />
                </mat-form-field>
            </div>
            <mat-hint class="mb-3"><span class="text-secondary fst-italic">Info: Dacă se completează numărul de
                    referință anterior, este obligatorie
                    introducerea de an -
                    document referință</span></mat-hint>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill">
                    <mat-label>Observații Document</mat-label>
                    <textarea matInput formControlName="observatii"
                        placeholder="Observații/Mențiuni/Conținut..."></textarea>
                    <mat-hint style="color: red;">
                        <strong><i>Aici se notează observațiile/mențiunile/conținutul
                                documentului/dosarului!</i></strong>
                    </mat-hint>
                    <mat-error *ngIf="!form.controls['observatii'].valid && form.controls['observatii'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8">
                <mat-form-field appearance="fill">
                    <mat-label>Cuvinte cheie</mat-label>
                    <input matInput type="text" formControlName="keywords" />
                    <mat-error *ngIf="!form.controls['keywords'].valid && form.controls['keywords'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <mat-form-field appearance="fill">
                    <mat-label>Număr Pagini</mat-label>
                    <input matInput type="number" formControlName="no_pages" />
                    <mat-error *ngIf="!form.controls['no_pages'].valid && form.controls['no_pages'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <ng-container *ngIf="registruOficialGeneralValue == form.get('id_serie')?.value || 
            (registruOficialGeneralValue != form.get('id_serie')?.value && showFormFiles)">
            <h3 class="m-0">Încărcați Documente <span class="text-danger">(*)</span></h3>
            <mat-divider class="divider-section"></mat-divider>
            <br>
            <form [formGroup]="formFiles">
                <div class="solicitare-card__upload mb-2">
                    <div class="solicitare-card__upload-header">
                        <p class="upload-text">Documente</p>
                        <button class="upload-btn" (click)="fileInput.click()" type="button">
                            <mat-icon class="upload-icon">cloud_upload</mat-icon>
                            ÎNCARCĂ
                        </button>
                    </div>
                    <div class="solicitare-card__upload-files" *ngIf="
                        formFiles.value.files &&
                        formFiles.value.files.length > 0 &&
                        !uploading
                    ">
                        <div class="solicitare-card__upload-file" *ngFor="
                            let uploadedFile of formFiles.value.files;
                            let i = index
                        ">
                            <span class="solicitare-card__upload-file-name">
                                {{
                                uploadedFile.original_name.length > 30
                                ? (uploadedFile.original_name | slice : 0 : 30) + ".."
                                : uploadedFile.original_name
                                }}
                            </span>
                            <div class="d-flex gap-4 align-items-center">
                                <button class="solicitare-card__upload-file-view" type="button"
                                    matTooltip="Vizualizează fișierul" (click)="downloadFile(uploadedFile)">
                                    <mat-icon class="btn-icon">visibility</mat-icon>
                                    <span class="btn-text">Vizualizează</span>
                                </button>
                                <button class="solicitare-card__upload-file-delete" type="button"
                                    matTooltip="Șterge fișierul încărcat" (click)="removeFile(i)">
                                    <img class="btn-img" src="../../../assets/icons/delete.svg" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="solicitare-card__upload-files" *ngIf="
                        formFiles.value.files &&
                        formFiles.value.files.length === 0 &&
                        !uploading
                    ">
                        <div class="solicitare-card__upload-file">
                            <div class="w-100 text-center">
                                <strong><i>Lipsă înregistrări</i></strong>
                            </div>
                        </div>
                    </div>
                    <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                        *ngIf="uploading"></mat-spinner>

                    <input type="file"
                        accept=".png, .jpg, .jpeg, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ods, .odt, .heic"
                        id="upload-file-input-0" #fileInput name="fileInput" (change)="addFile($event)" multiple
                        style="display: none" />
                </div>
            </form>
        </ng-container>

        <h3 class="m-0">Destinatar</h3>
        <mat-divider class="divider-section"></mat-divider>
        <br>
        <form [formGroup]="formEmitent">
            <div class="divider-container mb-2">
                <div class="line"></div>
                <span class="text">IDENTIFICARE</span>
                <div class="line"></div>
                <button class="ms-2 btn-reset-form"
                    (click)="resetFormEmitent(this.formEmitent.get('id_address_type')?.value)">
                    <i class="fa fa-eraser"></i>
                    <span>Curăță</span>
                </button>
            </div>

            <div class="row">
                <div [ngClass]="formEmitent.get('id_address_type')?.value !== 4 ? 'col-md-4' : 'col-md-12'">
                    <mat-form-field appearance="fill">
                        <mat-label>Tip Persoană/Instituție</mat-label>
                        <mat-select formControlName="id_address_type"
                            (selectionChange)="resetFormEmitent($event.value)">
                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                            <mat-option [value]="1">Cetățean</mat-option>
                            <mat-option [value]="2">Persoană Juridică</mat-option>
                            <mat-option [value]="3">Instituție Extern</mat-option>
                            <mat-option [value]="4">Instituție Intern</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <ng-container *ngIf="formEmitent.get('id_address_type')?.value === -1">
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Denumire</mat-label>
                            <input type="text" matInput formControlName="denumire" />
                            <mat-error
                                *ngIf="!formEmitent.controls['denumire'].valid && formEmitent.controls['denumire'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Persoană contact</mat-label>
                            <input type="text" matInput formControlName="pers_contact" />
                        </mat-form-field>
                    </div>
                </ng-container>
                <ng-container *ngIf="formEmitent.get('id_address_type')?.value === 1 || 
                    formEmitent.get('id_address_type')?.value === 2 ||
                    formEmitent.get('id_address_type')?.value === 3">
                    <div class="col-md-8">
                        <mat-form-field appearance="fill">
                            <mat-label *ngIf="formEmitent.get('id_address_type')?.value === 1">Nume complet -
                                Cetățean</mat-label>
                            <mat-label *ngIf="formEmitent.get('id_address_type')?.value === 2">Căutare:
                                Persoană Juridică => ID: n/a</mat-label>
                            <mat-label *ngIf="formEmitent.get('id_address_type')?.value === 3">Căutare:
                                Instituție Externă => ID: n/a</mat-label>
                            <input matInput [formControl]="entitatiEmitentControl"
                                [matAutocomplete]="autoEntitateEmitent" (change)="onEntitateEmitentChange()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>

                            <mat-autocomplete #autoEntitateEmitent="matAutocomplete"
                                [displayWith]="displayEntitateEmitent"
                                (optionSelected)="onEntitateEmitentSelected($event.option.value)">
                                <mat-option *ngIf="showEntitatiEmitentMessage" disabled>
                                    <span
                                        *ngIf="!entitatiEmitentControl.value || entitatiEmitentControl.value.length < 2">
                                        Vă rugăm să introduceți 2 caractere sau mai multe
                                    </span>
                                    <span
                                        *ngIf="isEntitatiEmitentLoading && entitatiEmitentControl.value && entitatiEmitentControl.value.length >= 2">Căutare...</span>
                                    <span
                                        *ngIf="!isEntitatiEmitentLoading && entitatiEmitentLoadComplete && entitatiEmitent.length === 0 && entitatiEmitentControl.value && entitatiEmitentControl.value.length >= 2">
                                        Nu au fost găsite rezultate
                                    </span>
                                </mat-option>

                                <mat-option *ngFor="let entitate of entitatiEmitent" [value]="entitate">
                                    {{ entitate.denumire }}
                                </mat-option>
                            </mat-autocomplete>
                            <mat-error
                                *ngIf="!formEmitent.controls['denumire_select'].valid && formEmitent.controls['denumire_select'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                </ng-container>
            </div>

            <ng-container *ngIf="formEmitent.get('id_address_type')?.value === 1">
                <div class="row">
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>CNP/CIF/Identificator</mat-label>
                            <input type="text" matInput [formControl]="entitatiEmitentByCNPControl"
                                [matAutocomplete]="autoEntitateEmitentByCNP"
                                (change)="onEntitateEmitentByCNPChange()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoEntitateEmitentByCNP="matAutocomplete"
                                [displayWith]="displayEntitateEmitentByCNP"
                                (optionSelected)="onEntitateEmitentByCNPSelected($event.option.value)">
                                <mat-option *ngIf="showEntitatiEmitentByCNPMessage" disabled>
                                    <span
                                        *ngIf="!entitatiEmitentByCNPControl.value || entitatiEmitentByCNPControl.value.length < 2">
                                        Vă rugăm să introduceți 2 caractere sau mai multe
                                    </span>
                                    <span
                                        *ngIf="isEntitatiEmitentByCNPLoading && entitatiEmitentByCNPControl.value && entitatiEmitentByCNPControl.value.length >= 2">Căutare...</span>
                                    <span
                                        *ngIf="!isEntitatiEmitentByCNPLoading && entitatiEmitentByCNPLoadComplete && entitatiEmitentByCNP.length === 0 && entitatiEmitentByCNPControl.value && entitatiEmitentByCNPControl.value.length >= 2">
                                        Nu au fost găsite rezultate
                                    </span>
                                </mat-option>

                                <mat-option *ngFor="let entitate of entitatiEmitentByCNP" [value]="entitate">
                                    {{ entitate.cnp_cui }}
                                </mat-option>
                            </mat-autocomplete>
                            <mat-error
                                *ngIf="!entitatiEmitentByCNPControl.valid && entitatiEmitentByCNPControl.touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Email</mat-label>
                            <input type="text" matInput formControlName="email" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Telefon</mat-label>
                            <input type="text" matInput formControlName="telefon" />
                        </mat-form-field>
                    </div>
                </div>

                <div *ngIf="this.entitatiEmitentControl.value?.data_deces || this.entitatiEmitentByCNPControl.value?.data_deces"
                    class="warning-label">Emitent decedat!</div>
            </ng-container>

            <ng-container *ngIf="formEmitent.get('id_address_type')?.value === 1 ||
                formEmitent.get('id_address_type')?.value === 2 || formEmitent.get('id_address_type')?.value === 3">
                <div class="divider-container">
                    <div class="line"></div>
                    <span class="text">Sau introduceți/adăugare</span>
                    <div class="line"></div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="fill">
                            <mat-label>Denumire</mat-label>
                            <input type="text" matInput formControlName="denumire" />
                            <mat-error
                                *ngIf="!formEmitent.controls['denumire'].valid && formEmitent.controls['denumire'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div *ngIf="formEmitent.get('id_address_type')?.value !== 1" class="col-md-6">
                        <mat-form-field appearance="fill">
                            <mat-label>Persoană contact</mat-label>
                            <input type="text" matInput formControlName="pers_contact" />
                        </mat-form-field>
                    </div>

                    <div class="row" *ngIf="formEmitent.get('id_address_type')?.value === 2">
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>CNP/CIF/Identificator</mat-label>
                                <input type="text" matInput [formControl]="entitatiEmitentByCNPControl"
                                    [matAutocomplete]="autoEntitateEmitentByCNP"
                                    (change)="onEntitateEmitentByCNPChange()" />
                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                <mat-autocomplete #autoEntitateEmitentByCNP="matAutocomplete"
                                    [displayWith]="displayEntitateEmitentByCNP"
                                    (optionSelected)="onEntitateEmitentByCNPSelected($event.option.value)">
                                    <mat-option *ngIf="showEntitatiEmitentByCNPMessage" disabled>
                                        <span
                                            *ngIf="!entitatiEmitentByCNPControl.value || entitatiEmitentByCNPControl.value.length < 2">
                                            Vă rugăm să introduceți 2 caractere sau mai multe
                                        </span>
                                        <span
                                            *ngIf="isEntitatiEmitentByCNPLoading && entitatiEmitentByCNPControl.value && entitatiEmitentByCNPControl.value.length >= 2">Căutare...</span>
                                        <span
                                            *ngIf="!isEntitatiEmitentByCNPLoading && entitatiEmitentByCNPLoadComplete && entitatiEmitentByCNP.length === 0 && entitatiEmitentByCNPControl.value && entitatiEmitentByCNPControl.value.length >= 2">
                                            Nu au fost găsite rezultate
                                        </span>
                                    </mat-option>

                                    <mat-option *ngFor="let entitate of entitatiEmitentByCNP" [value]="entitate">
                                        {{ entitate.cnp_cui }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="!entitatiEmitentByCNPControl && entitatiEmitentByCNPControl">
                                    Câmp obligatoriu
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Email</mat-label>
                                <input type="text" matInput formControlName="email" />
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Telefon</mat-label>
                                <input type="text" matInput formControlName="telefon" />
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div *ngIf="formEmitent.get('id_address_type')?.value === 1" class="mb-2">
                    <mat-error
                        *ngIf="!formEmitent.get('denumire_select')?.value && !formEmitent.get('denumire')?.value">
                        Câmpul 'Nume complet - Cetățean' sau câmpul 'Denumire' este obligatoriu,
                        deci minim unul din câmpuri de completat.
                    </mat-error>
                </div>
                <div *ngIf="formEmitent.get('id_address_type')?.value === 2 ||
                    formEmitent.get('id_address_type')?.value === 3" class="mb-2">
                    <mat-error
                        *ngIf="!formEmitent.get('denumire_select')?.value && !formEmitent.get('denumire')?.value">
                        Câmpul 'Căutare: Persoană Juridică/Institutie Externă' sau câmpul 'Denumire' este obligatoriu,
                        deci minim unul din câmpuri de completat.
                    </mat-error>
                </div>
            </ng-container>

            <ng-container *ngIf="formEmitent.get('id_address_type')?.value === 4">
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Instituție/Direcție</mat-label>
                            <input matInput [formControl]="directiiEmitentControl"
                                [matAutocomplete]="autoDirectiiEmitent" (blur)="onDirectiiEmitentBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoDirectiiEmitent="matAutocomplete"
                                [displayWith]="displayDirectiiEmitent"
                                (optionSelected)="onDirectiiEmitentChange($event.option.value)">
                                <mat-option *ngIf="filteredDirectiiEmitent.length === 0" disabled>
                                    Nu au fost găsite rezultate
                                </mat-option>
                                <mat-option *ngFor="let directie of filteredDirectiiEmitent" [value]="directie">
                                    {{ directie.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Compartiment/Departament</mat-label>
                            <input matInput [formControl]="compartimenteEmitentControl"
                                [matAutocomplete]="autoCompartimenteEmitent" (blur)="onCompartimenteEmitentBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoCompartimenteEmitent="matAutocomplete"
                                [displayWith]="displayCompartimenteEmitent"
                                (optionSelected)="onCompartimenteEmitentSelected($event.option.value)">
                                <mat-option *ngIf="showCompartimenteEmitentMessage" disabled>
                                    <span
                                        *ngIf="!compartimenteEmitentControl.value || compartimenteEmitentControl.value.length < 2">
                                        Vă rugăm să introduceți 2 caractere sau mai multe
                                    </span>
                                    <span
                                        *ngIf="isCompartimenteEmitentLoading && compartimenteEmitentControl.value && compartimenteEmitentControl.value.length >= 2">Căutare...</span>
                                    <span
                                        *ngIf="!isCompartimenteEmitentLoading && compartimenteEmitentLoadComplete && compartimenteEmitent.length === 0 && compartimenteEmitentControl.value && compartimenteEmitentControl.value.length >= 2">
                                        Nu au fost găsite rezultate
                                    </span>
                                </mat-option>

                                <mat-option *ngFor="let compartiment of compartimenteEmitent" [value]="compartiment">
                                    {{ compartiment.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Alegeți un operator</mat-label>
                            <mat-select formControlName="user_id"
                                (selectionChange)="onOperatoriEmitentChange($event.value)">
                                <!-- <mat-form-field class="px-2 sticky-input">
                                    <input matInput [formControl]="operatoriEmitentControl"
                                        (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                </mat-form-field> -->

                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let operator of filteredOperatoriEmitent" [value]="operator.id">
                                    {{ operator.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="(formEmitent.get('id_address_type')?.value === 1 ||
                formEmitent.get('id_address_type')?.value === 2 ||
                formEmitent.get('id_address_type')?.value === 3)">
                <div class="divider-container">
                    <div class="line"></div>
                    <span class="text">ADRESĂ/SEDIU</span>
                    <div class="line"></div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Țară</mat-label>
                            <input matInput [formControl]="tariEmitentControl" [matAutocomplete]="autoTariEmitent"
                                (blur)="onTariEmitentBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoTariEmitent="matAutocomplete" [displayWith]="displayTariEmitent"
                                (optionSelected)="onTariEmitentChange($event.option.value)">
                                <mat-option *ngIf="filteredTariEmitent.length === 0" disabled>
                                    Nu au fost găsite rezultate
                                </mat-option>
                                <mat-option *ngFor="let tara of filteredTariEmitent" [value]="tara">
                                    {{ tara.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Județ</mat-label>
                            <input matInput [formControl]="judeteEmitentControl" [matAutocomplete]="autoJudeteEmitent"
                                (blur)="onJudeteEmitentBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoJudeteEmitent="matAutocomplete" [displayWith]="displayJudeteEmitent"
                                (optionSelected)="onJudeteEmitentChange($event.option.value)">
                                <mat-option *ngIf="filteredJudeteEmitent.length === 0" disabled>
                                    Nu au fost găsite rezultate
                                </mat-option>
                                <mat-option *ngFor="let judet of filteredJudeteEmitent" [value]="judet">
                                    {{ judet.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Localitate</mat-label>
                            <input matInput [formControl]="localitatiEmitentControl"
                                [matAutocomplete]="autoLocalitatiEmitent" (blur)="onLocalitatiEmitentBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoLocalitatiEmitent="matAutocomplete"
                                [displayWith]="displayLocalitatiEmitent"
                                (optionSelected)="onLocalitatiEmitentSelected($event.option.value)">
                                <mat-option *ngIf="showLocalitatiEmitentMessage" disabled>
                                    <span
                                        *ngIf="!localitatiEmitentControl.value || localitatiEmitentControl.value.length < 2">
                                        Vă rugăm să introduceți 2 caractere sau mai multe
                                    </span>
                                    <span
                                        *ngIf="isLocalitatiEmitentLoading && localitatiEmitentControl.value && localitatiEmitentControl.value.length >= 2">Căutare...</span>
                                    <span
                                        *ngIf="!isLocalitatiEmitentLoading && localitatiEmitentLoadComplete && localitatiEmitent.length === 0 && localitatiEmitentControl.value && localitatiEmitentControl.value.length >= 2">
                                        Nu au fost găsite rezultate
                                    </span>
                                </mat-option>

                                <mat-option *ngFor="let localitate of localitatiEmitent" [value]="localitate">
                                    {{ localitate.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Sector</mat-label>
                            <mat-select formControlName="sector">
                                <mat-option value="-1">--Alegeți--</mat-option>
                                <mat-option value="1">Sector 1</mat-option>
                                <mat-option value="2">Sector 2</mat-option>
                                <mat-option value="3">Sector 3</mat-option>
                                <mat-option value="4">Sector 4</mat-option>
                                <mat-option value="5">Sector 5</mat-option>
                                <mat-option value="6">Sector 6</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4 d-flex flex-row gap-1">
                        <mat-form-field appearance="fill">
                            <mat-label>Stradă</mat-label>
                            <input matInput [formControl]="straziEmitentControl" [matAutocomplete]="autoStraziEmitent"
                                (blur)="onStraziEmitentBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoStraziEmitent="matAutocomplete" [displayWith]="displayStraziEmitent"
                                (optionSelected)="onStraziEmitentSelected($event.option.value)">
                                <mat-option *ngIf="showStraziEmitentMessage" disabled>
                                    <span *ngIf="!straziEmitentControl.value || straziEmitentControl.value.length < 2">
                                        Vă rugăm să introduceți 2 caractere sau mai multe
                                    </span>
                                    <span
                                        *ngIf="isStraziEmitentLoading && straziEmitentControl.value && straziEmitentControl.value.length >= 2">Căutare...</span>
                                    <span
                                        *ngIf="!isStraziEmitentLoading && straziEmitentLoadComplete && straziEmitent.length === 0 && straziEmitentControl.value && straziEmitentControl.value.length >= 2">
                                        Nu au fost găsite rezultate
                                    </span>
                                </mat-option>

                                <mat-option *ngFor="let strada of straziEmitent" [value]="strada">
                                    {{ strada.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <button
                            *ngIf="!isStraziEmitentLoading && straziEmitentLoadComplete && straziEmitent.length === 0 && straziEmitentControl.value && straziEmitentControl.value.length >= 2"
                            type="button" class="btn-add-entry" (click)="addStraziEmitent()">
                            <i class="icon fa fa-add"></i>
                        </button>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Număr</mat-label>
                            <input type="text" matInput formControlName="numar" />
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Bloc</mat-label>
                            <input type="text" matInput formControlName="bloc" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Scară</mat-label>
                            <input type="text" matInput formControlName="scara" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Apartament</mat-label>
                            <input type="text" matInput formControlName="apartament" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Cod Poștal</mat-label>
                            <input type="text" matInput formControlName="cod_postal" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div *ngIf="formEmitent.get('id_address_type')?.value === 1" class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Număr document deces</mat-label>
                            <input type="text" matInput formControlName="numar_deces" />
                        </mat-form-field>
                    </div>
                    <div *ngIf="formEmitent.get('id_address_type')?.value === 1" class="col-md-4">
                        <mat-form-field>
                            <mat-label>Dată deces</mat-label>
                            <input matInput [max]="today" [matDatepicker]="dateDecesPicker"
                                formControlName="data_deces_input" placeholder="Dacă există..." readonly
                                (focus)="dateDecesPicker.open()" />
                            <mat-hint>ZZ/LL/AAAA</mat-hint>
                            <mat-datepicker-toggle matIconSuffix [for]="dateDecesPicker"></mat-datepicker-toggle>
                            <mat-datepicker #dateDecesPicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-checkbox [ngClass]="formEmitent.get('id_address_type')?.value === 1 ? 'mt-md-2' : 'mb-2'"
                            color="primary" formControlName="person_status">
                            Verificare evidența persoanelor
                        </mat-checkbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Observații</mat-label>
                            <textarea matInput formControlName="observatii"
                                placeholder="Dacă există observații..."></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>
        </form>

        <div class="d-flex justify-content-between align-items-center mb-2">
            <h3 class=" m-0">Spre știință</h3>
            <button (click)="toggleStiintaFullForm()" class="btn-search small-btn"
                [ngClass]="showStiintaFullForm ? 'active-btn' : 'default-btn'">
                {{ showStiintaFullForm ? 'Ascunde Formular' : 'Afișează Formular' }}
            </button>
        </div>
        <mat-divider class="divider-section"></mat-divider>
        <br>
        <div *ngIf="toStiintaRecords.length > 0" class="mb-2">
            <div class="divider-container">
                <div class="line"></div>
                <span class="text">ÎNREGISTRĂRI</span>
                <div class="line"></div>
            </div>
            <div *ngFor="let row of toStiintaRecords; let i = index">
                <mat-divider class="my-2"></mat-divider>
                <div class="row">
                    <div class="col-1">
                        <strong>{{ i + 1 }}.</strong>
                    </div>
                    <div class="col-10">
                        <ng-container *ngIf="row.id_address_type === -1">
                            <div *ngIf="row.denumire"><strong>Denumire:</strong> {{ row.denumire }}</div>
                            <div *ngIf="row.denumire_select"><strong>Denumire (select):</strong> {{
                                row.denumire_select}}</div>
                        </ng-container>
                        <ng-container
                            *ngIf="row.id_address_type === 1 || row.id_address_type === 2 || row.id_address_type === 3">
                            <div *ngIf="row.denumire"><strong>Denumire:</strong> {{ row.denumire }}</div>
                            <div *ngIf="row.denumire_select"><strong>Denumire (select):</strong> {{
                                row.denumire_select}}</div>
                            <div *ngIf="row.email" class="mt-2"><strong>Email:</strong> {{ row.email }}</div>
                            <div *ngIf="row.telefon" class="mt-2"><strong>Telefon:</strong> {{ row.telefon }}</div>
                            <div *ngIf="row.cnp_cui" class="mt-2"><strong>CNP/CUI:</strong> {{ row.cnp_cui }}</div>
                            <div class="mt-2"><strong>Adresă:</strong> {{ row.name_tara || 'n/a' }}, {{
                                row.name_judet || 'n/a' }}, {{ row.name_localitate || 'n/a' }}, str. {{
                                row.name_strada || 'n/a' }}, nr. {{ row.numar || 'n/a' }}, bl. {{ row.bloc || 'n/a'
                                }}, sc. {{ row.scara || 'n/a' }}, ap. {{ row.apartament || 'n/a' }}</div>
                        </ng-container>
                        <ng-container *ngIf="row.id_address_type === 4">
                            <div *ngIf="row.directie_name"><strong>Instituție:</strong> {{ row.directie_name }}
                            </div>
                            <div *ngIf="row.compartiment_name" class="mt-2"><strong>Serviciu/Birou:</strong> {{
                                row.compartiment_name }}</div>
                            <div *ngIf="row.user_name" class="mt-2"><strong>Operator:</strong> {{ row.user_name }}
                            </div>
                        </ng-container>
                    </div>
                    <div class="col-1">
                        <button class="action-btn delete" (click)="deleteStiintaRecord(i)">
                            <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <form *ngIf="showStiintaFullForm" [formGroup]="formStiinta">
            <div class="divider-container">
                <div class="line"></div>
                <span class="text">SELECTARE</span>
                <div class="line"></div>
            </div>
            <button (click)="toggleStiintaInfoForm()" class="btn-search my-2"
                [ngClass]="showStiintaInfoForm ? 'active-btn' : 'default-btn'">
                {{ showStiintaInfoForm ? 'Ascunde Formular' : 'Adaugă' }} Informații Cetățean/Persoană
                Juridică/Instituție
            </button>

            <div class="divider-container">
                <div class="line"></div>
                <span class="text">IDENTIFICARE</span>
                <div class="line"></div>
            </div>

            <div class="row">
                <div [ngClass]="formStiinta.get('id_address_type')?.value !== 4 ? 'col-md-4' : 'col-md-12'">
                    <mat-form-field appearance="fill">
                        <mat-label>Tip Persoană/Instituție</mat-label>
                        <mat-select formControlName="id_address_type"
                            (selectionChange)="resetFormStiinta($event.value)">
                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                            <mat-option [value]="1">Cetățean</mat-option>
                            <mat-option [value]="2">Persoană Juridică</mat-option>
                            <mat-option [value]="3">Instituție Extern</mat-option>
                            <mat-option [value]="4">Instituție Intern</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <ng-container *ngIf="formStiinta.get('id_address_type')?.value === -1">
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Denumire</mat-label>
                            <input type="text" matInput formControlName="denumire" />
                            <mat-error
                                *ngIf="!formStiinta.controls['denumire'].valid && formStiinta.controls['denumire'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Persoană contact</mat-label>
                            <input type="text" matInput formControlName="pers_contact" />
                        </mat-form-field>
                    </div>
                </ng-container>
                <ng-container *ngIf="formStiinta.get('id_address_type')?.value === 1 || 
                    formStiinta.get('id_address_type')?.value === 2 ||
                    formStiinta.get('id_address_type')?.value === 3">
                    <div class="col-md-8">
                        <mat-form-field appearance="fill">
                            <mat-label *ngIf="formStiinta.get('id_address_type')?.value === 1">Nume complet -
                                Cetățean</mat-label>
                            <mat-label *ngIf="formStiinta.get('id_address_type')?.value === 2">Căutare:
                                Persoană Juridică => ID: n/a</mat-label>
                            <mat-label *ngIf="formStiinta.get('id_address_type')?.value === 3">Căutare:
                                Instituție Externă => ID: n/a</mat-label>
                            <input matInput [formControl]="entitatiStiintaControl"
                                [matAutocomplete]="autoEntitateStiinta" (change)="onEntitateStiintaChange()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>

                            <mat-autocomplete #autoEntitateStiinta="matAutocomplete"
                                [displayWith]="displayEntitateStiinta"
                                (optionSelected)="onEntitateStiintaSelected($event.option.value)">
                                <mat-option *ngIf="showEntitatiStiintaMessage" disabled>
                                    <span
                                        *ngIf="!entitatiStiintaControl.value || entitatiStiintaControl.value.length < 2">
                                        Vă rugăm să introduceți 2 caractere sau mai multe
                                    </span>
                                    <span
                                        *ngIf="isEntitatiStiintaLoading && entitatiStiintaControl.value && entitatiStiintaControl.value.length >= 2">Căutare...</span>
                                    <span
                                        *ngIf="!isEntitatiStiintaLoading && entitatiStiintaLoadComplete && entitatiStiinta.length === 0 && entitatiStiintaControl.value && entitatiStiintaControl.value.length >= 2">
                                        Nu au fost găsite rezultate
                                    </span>
                                </mat-option>

                                <mat-option *ngFor="let entitate of entitatiStiinta" [value]="entitate">
                                    {{ entitate.denumire }}
                                </mat-option>
                            </mat-autocomplete>
                            <mat-error
                                *ngIf="!formStiinta.controls['denumire_select'].valid && formStiinta.controls['denumire_select'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                </ng-container>
            </div>

            <ng-container *ngIf="formStiinta.get('id_address_type')?.value === 1">
                <div class="row">
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>CNP/CIF/Identificator</mat-label>
                            <input type="text" matInput [formControl]="entitatiStiintaByCNPControl"
                                [matAutocomplete]="autoEntitateStiintaByCNP"
                                (change)="onEntitateStiintaByCNPChange()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoEntitateStiintaByCNP="matAutocomplete"
                                [displayWith]="displayEntitateStiintaByCNP"
                                (optionSelected)="onEntitateStiintaByCNPSelected($event.option.value)">
                                <mat-option *ngIf="showEntitatiStiintaByCNPMessage" disabled>
                                    <span
                                        *ngIf="!entitatiStiintaByCNPControl.value || entitatiStiintaByCNPControl.value.length < 2">
                                        Vă rugăm să introduceți 2 caractere sau mai multe
                                    </span>
                                    <span
                                        *ngIf="isEntitatiStiintaByCNPLoading && entitatiStiintaByCNPControl.value && entitatiStiintaByCNPControl.value.length >= 2">Căutare...</span>
                                    <span
                                        *ngIf="!isEntitatiStiintaByCNPLoading && entitatiStiintaByCNPLoadComplete && entitatiStiintaByCNP.length === 0 && entitatiStiintaByCNPControl.value && entitatiStiintaByCNPControl.value.length >= 2">
                                        Nu au fost găsite rezultate
                                    </span>
                                </mat-option>

                                <mat-option *ngFor="let entitate of entitatiStiintaByCNP" [value]="entitate">
                                    {{ entitate.cnp_cui }}
                                </mat-option>
                            </mat-autocomplete>
                            <mat-error
                                *ngIf="!formStiinta.controls['cnp_cui'].valid && formStiinta.controls['cnp_cui'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Email</mat-label>
                            <input type="text" matInput formControlName="email" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Telefon</mat-label>
                            <input type="text" matInput formControlName="telefon" />
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="formStiinta.get('id_address_type')?.value === 1 ||
                formStiinta.get('id_address_type')?.value === 2 || formStiinta.get('id_address_type')?.value === 3">
                <div class="divider-container">
                    <div class="line"></div>
                    <span class="text">Sau introduceți/adăugare</span>
                    <div class="line"></div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="fill">
                            <mat-label>Denumire</mat-label>
                            <input type="text" matInput formControlName="denumire" />
                            <mat-error
                                *ngIf="!formStiinta.controls['denumire'].valid && formStiinta.controls['denumire'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div *ngIf="formStiinta.get('id_address_type')?.value !== 1" class="col-md-6">
                        <mat-form-field appearance="fill">
                            <mat-label>Persoană contact</mat-label>
                            <input type="text" matInput formControlName="pers_contact" />
                        </mat-form-field>
                    </div>

                    <div class="row" *ngIf="formStiinta.get('id_address_type')?.value === 2">
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>CNP/CIF/Identificator</mat-label>
                                <input type="text" matInput [formControl]="entitatiStiintaByCNPControl"
                                    [matAutocomplete]="autoEntitateStiintaByCNP"
                                    (change)="onEntitateStiintaByCNPChange()" />
                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                <mat-autocomplete #autoEntitateStiintaByCNP="matAutocomplete"
                                    [displayWith]="displayEntitateStiintaByCNP"
                                    (optionSelected)="onEntitateStiintaByCNPSelected($event.option.value)">
                                    <mat-option *ngIf="showEntitatiStiintaByCNPMessage" disabled>
                                        <span
                                            *ngIf="!entitatiStiintaByCNPControl.value || entitatiStiintaByCNPControl.value.length < 2">
                                            Vă rugăm să introduceți 2 caractere sau mai multe
                                        </span>
                                        <span
                                            *ngIf="isEntitatiStiintaByCNPLoading && entitatiStiintaByCNPControl.value && entitatiStiintaByCNPControl.value.length >= 2">Căutare...</span>
                                        <span
                                            *ngIf="!isEntitatiStiintaByCNPLoading && entitatiStiintaByCNPLoadComplete && entitatiStiintaByCNP.length === 0 && entitatiStiintaByCNPControl.value && entitatiStiintaByCNPControl.value.length >= 2">
                                            Nu au fost găsite rezultate
                                        </span>
                                    </mat-option>

                                    <mat-option *ngFor="let entitate of entitatiStiintaByCNP" [value]="entitate">
                                        {{ entitate.cnp_cui }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-error
                                    *ngIf="!formStiinta.controls['cnp_cui'].valid && formStiinta.controls['cnp_cui'].touched">
                                    Câmp obligatoriu
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Email</mat-label>
                                <input type="text" matInput formControlName="email" />
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Telefon</mat-label>
                                <input type="text" matInput formControlName="telefon" />
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div *ngIf="formStiinta.get('id_address_type')?.value === 1" class="mb-2">
                    <mat-error
                        *ngIf="!formStiinta.get('denumire_select')?.value && !formStiinta.get('denumire')?.value">
                        Câmpul 'Nume complet - Cetățean' sau câmpul 'Denumire' este obligatoriu,
                        deci minim unul din câmpuri de completat.
                    </mat-error>
                </div>
                <div *ngIf="formStiinta.get('id_address_type')?.value === 2 ||
                    formStiinta.get('id_address_type')?.value === 3" class="mb-2">
                    <mat-error
                        *ngIf="!formStiinta.get('denumire_select')?.value && !formStiinta.get('denumire')?.value">
                        Câmpul 'Căutare: Persoană Juridică/Institutie Externă' sau câmpul 'Denumire' este obligatoriu,
                        deci minim unul din câmpuri de completat.
                    </mat-error>
                </div>
            </ng-container>

            <ng-container *ngIf="formStiinta.get('id_address_type')?.value === 4">
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Instituție/Direcție</mat-label>
                            <input matInput [formControl]="directiiStiintaControl"
                                [matAutocomplete]="autoDirectiiStiinta" (blur)="onDirectiiStiintaBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoDirectiiStiinta="matAutocomplete"
                                [displayWith]="displayDirectiiStiinta"
                                (optionSelected)="onDirectiiStiintaChange($event.option.value)">
                                <mat-option *ngIf="filteredDirectiiStiinta.length === 0" disabled>
                                    Nu au fost găsite rezultate
                                </mat-option>
                                <mat-option *ngFor="let directie of filteredDirectiiStiinta" [value]="directie">
                                    {{ directie.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Compartiment/Departament</mat-label>
                            <input matInput [formControl]="compartimenteStiintaControl"
                                [matAutocomplete]="autoCompartimenteStiinta" (blur)="onCompartimenteStiintaBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoCompartimenteStiinta="matAutocomplete"
                                [displayWith]="displayCompartimenteStiinta"
                                (optionSelected)="onCompartimenteStiintaSelected($event.option.value)">
                                <mat-option *ngIf="showCompartimenteStiintaMessage" disabled>
                                    <span
                                        *ngIf="!compartimenteStiintaControl.value || compartimenteStiintaControl.value.length < 2">
                                        Vă rugăm să introduceți 2 caractere sau mai multe
                                    </span>
                                    <span
                                        *ngIf="isCompartimenteStiintaLoading && compartimenteStiintaControl.value && compartimenteStiintaControl.value.length >= 2">Căutare...</span>
                                    <span
                                        *ngIf="!isCompartimenteStiintaLoading && compartimenteStiintaLoadComplete && compartimenteStiinta.length === 0 && compartimenteStiintaControl.value && compartimenteStiintaControl.value.length >= 2">
                                        Nu au fost găsite rezultate
                                    </span>
                                </mat-option>

                                <mat-option *ngFor="let compartiment of compartimenteStiinta" [value]="compartiment">
                                    {{ compartiment.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Alegeți un operator</mat-label>
                            <mat-select formControlName="user_id"
                                (selectionChange)="onOperatoriStiintaChange($event.value)">
                                <!-- <mat-form-field class="px-2 sticky-input">
                                    <input matInput [formControl]="operatoriStiintaControl"
                                        (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                </mat-form-field> -->

                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let operator of filteredOperatoriStiinta" [value]="operator.id">
                                    {{ operator.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="showStiintaInfoForm && (formStiinta.get('id_address_type')?.value === 1 ||
                formStiinta.get('id_address_type')?.value === 2 ||
                formStiinta.get('id_address_type')?.value === 3)">
                <div class="divider-container">
                    <div class="line"></div>
                    <span class="text">ADRESĂ/SEDIU</span>
                    <div class="line"></div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Țară</mat-label>
                            <input matInput [formControl]="tariStiintaControl" [matAutocomplete]="autoTariStiinta"
                                (blur)="onTariStiintaBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoTariStiinta="matAutocomplete" [displayWith]="displayTariStiinta"
                                (optionSelected)="onTariStiintaChange($event.option.value)">
                                <mat-option *ngIf="filteredTariStiinta.length === 0" disabled>
                                    Nu au fost găsite rezultate
                                </mat-option>
                                <mat-option *ngFor="let tara of filteredTariStiinta" [value]="tara">
                                    {{ tara.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Județ</mat-label>
                            <input matInput [formControl]="judeteStiintaControl" [matAutocomplete]="autoJudeteStiinta"
                                (blur)="onJudeteStiintaBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoJudeteStiinta="matAutocomplete" [displayWith]="displayJudeteStiinta"
                                (optionSelected)="onJudeteStiintaChange($event.option.value)">
                                <mat-option *ngIf="filteredJudeteStiinta.length === 0" disabled>
                                    Nu au fost găsite rezultate
                                </mat-option>
                                <mat-option *ngFor="let judet of filteredJudeteStiinta" [value]="judet">
                                    {{ judet.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Localitate</mat-label>
                            <input matInput [formControl]="localitatiStiintaControl"
                                [matAutocomplete]="autoLocalitatiStiinta" (blur)="onLocalitatiStiintaBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoLocalitatiStiinta="matAutocomplete"
                                [displayWith]="displayLocalitatiStiinta"
                                (optionSelected)="onLocalitatiStiintaSelected($event.option.value)">
                                <mat-option *ngIf="showLocalitatiStiintaMessage" disabled>
                                    <span
                                        *ngIf="!localitatiStiintaControl.value || localitatiStiintaControl.value.length < 2">
                                        Vă rugăm să introduceți 2 caractere sau mai multe
                                    </span>
                                    <span
                                        *ngIf="isLocalitatiStiintaLoading && localitatiStiintaControl.value && localitatiStiintaControl.value.length >= 2">Căutare...</span>
                                    <span
                                        *ngIf="!isLocalitatiStiintaLoading && localitatiStiintaLoadComplete && localitatiStiinta.length === 0 && localitatiStiintaControl.value && localitatiStiintaControl.value.length >= 2">
                                        Nu au fost găsite rezultate
                                    </span>
                                </mat-option>

                                <mat-option *ngFor="let localitate of localitatiStiinta" [value]="localitate">
                                    {{ localitate.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Sector</mat-label>
                            <mat-select formControlName="sector">
                                <mat-option value="-1">--Alegeți--</mat-option>
                                <mat-option value="1">Sector 1</mat-option>
                                <mat-option value="2">Sector 2</mat-option>
                                <mat-option value="3">Sector 3</mat-option>
                                <mat-option value="4">Sector 4</mat-option>
                                <mat-option value="5">Sector 5</mat-option>
                                <mat-option value="6">Sector 6</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4 d-flex flex-row gap-1">
                        <mat-form-field appearance="fill">
                            <mat-label>Stradă</mat-label>
                            <input matInput [formControl]="straziStiintaControl" [matAutocomplete]="autoStraziStiinta"
                                (blur)="onStraziStiintaBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoStraziStiinta="matAutocomplete" [displayWith]="displayStraziStiinta"
                                (optionSelected)="onStraziStiintaSelected($event.option.value)">
                                <mat-option *ngIf="showStraziStiintaMessage" disabled>
                                    <span *ngIf="!straziStiintaControl.value || straziStiintaControl.value.length < 2">
                                        Vă rugăm să introduceți 2 caractere sau mai multe
                                    </span>
                                    <span
                                        *ngIf="isStraziStiintaLoading && straziStiintaControl.value && straziStiintaControl.value.length >= 2">Căutare...</span>
                                    <span
                                        *ngIf="!isStraziStiintaLoading && straziStiintaLoadComplete && straziStiinta.length === 0 && straziStiintaControl.value && straziStiintaControl.value.length >= 2">
                                        Nu au fost găsite rezultate
                                    </span>
                                </mat-option>

                                <mat-option *ngFor="let strada of straziStiinta" [value]="strada">
                                    {{ strada.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <button
                            *ngIf="!isStraziStiintaLoading && straziStiintaLoadComplete && straziStiinta.length === 0 && straziStiintaControl.value && straziStiintaControl.value.length >= 2"
                            type="button" class="btn-add-entry" (click)="addStraziStiinta()">
                            <i class="icon fa fa-add"></i>
                        </button>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Număr</mat-label>
                            <input type="text" matInput formControlName="numar" />
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Bloc</mat-label>
                            <input type="text" matInput formControlName="bloc" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Scară</mat-label>
                            <input type="text" matInput formControlName="scara" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Apartament</mat-label>
                            <input type="text" matInput formControlName="apartament" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Cod Poștal</mat-label>
                            <input type="text" matInput formControlName="cod_postal" />
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Observații</mat-label>
                            <textarea matInput formControlName="observatii"
                                placeholder="Dacă există observații..."></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>

            <button (click)="addStiintaRecord()" class="btn-search mt-2 mb-3 default-btn">
                Adaugă spre Știință
            </button>
        </form>

        <div class="row">
            <h5 class="mb-3"><span class="text-danger">*</span> <i>Câmpuri obligatorii</i></h5>
            <div class="col d-flex gap-2 justify-content-between flex-wrap">
                <button class="buttons" type="button" mat-stroked-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <div class="d-flex gap-2 flex-wrap">
                    <button class="buttons" type="submit" mat-flat-button color="primary" (click)="submitForm()">
                        Înregistrează
                    </button>
                    <button class="buttons" type="submit" mat-flat-button color="success" (click)="submitForm(true)">
                        Înregistrează și finalizează
                    </button>
                </div>
            </div>
        </div>
    </form>
    <div class="section-spinner position-fixed" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>